export type UILibrarySectionId =
  | 'tokens'
  | 'primitives'
  | 'icons'
  | 'feedback'
  | 'layout'
  | 'overlay'
  | 'navigation'
  | 'data-display'
  | 'forms'
  | 'patterns';

export interface UILibrarySectionConfig {
  id: UILibrarySectionId;
  labelKey: string;
}

export const UI_LIBRARY_SECTIONS: UILibrarySectionConfig[] = [
  { id: 'tokens', labelKey: 'uiLibrary.nav.tokens' },
  { id: 'primitives', labelKey: 'uiLibrary.nav.primitives' },
  { id: 'icons', labelKey: 'uiLibrary.nav.icons' },
  { id: 'feedback', labelKey: 'uiLibrary.nav.feedback' },
  { id: 'layout', labelKey: 'uiLibrary.nav.layout' },
  { id: 'overlay', labelKey: 'uiLibrary.nav.overlay' },
  { id: 'navigation', labelKey: 'uiLibrary.nav.navigation' },
  { id: 'data-display', labelKey: 'uiLibrary.nav.dataDisplay' },
  { id: 'forms', labelKey: 'uiLibrary.nav.forms' },
  { id: 'patterns', labelKey: 'uiLibrary.nav.patterns' },
];
